(function($) {
  $(document).ready(function() {
    // FLICKITY SLIDER init
    $(".main-carousel").flickity({
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      arrowShape: "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z",
      pageDots: false
    });

    $(".horizontal-links-slider").flickity({
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false
    });

    // FLICKITY SLIDER FIX for iPhones
    (function() {
      var touchingCarousel = false,
        touchStartCoords;

      document.body.addEventListener("touchstart", function(e) {
        if (e.target.closest(".flickity-slider")) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }

        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      });

      document.body.addEventListener(
        "touchmove",
        function(e) {
          if (!(touchingCarousel && e.cancelable)) {
            return;
          }

          var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y
          };

          if (Math.abs(moveVector.x) > 7) e.preventDefault();
        },
        { passive: false }
      );
    })();

    // BIG ISSUES links list functionality
    $(".links-slider__item").on("click", function() {
      if ($(".links-slider__item").hasClass("links-slider__item--active")) {
        $(".links-slider__item").removeClass("links-slider__item--active");
      }

      $(this).addClass("links-slider__item--active");

      var background =
        'linear-gradient(rgba(0,0,0,.4), rgba(0,0,0,.4)), url("' +
        $(this)[0].dataset.background +
        '")';
      var icon = $(this)
        .children(".links-slider__img")
        .children("i")[0].className;
      var subject = $(this)
        .children("span")
        .text();
      var text = $(this)[0].dataset.text;
      var link = $(this)[0].dataset.link;

      $(".big-issues").css("background-image", background);
      $(".big-issues__icon")
        .children("i")
        .removeClass()
        .addClass(icon);
      $(".big-issues__title").text(subject);
      $(".big-issues__paragraph").text(text);

      $("#big-issue-top-title")
        .children("span")
        .text(subject);
      $("#big-issue-top-title")
        .children("i")
        .removeClass()
        .addClass(icon);
      $(".big-issues__btn").attr("href", link);
    });

    // HEADER NAV functionality
    var firstImage = '';
    var subHeaderId = '';
    var triggeredFromHover = false;

    function headerNavChanger() {
      $(".header__item").on("mouseenter", function() {
        if (window.innerWidth > 1050) {
          $(".header__item").removeClass("header__item--hover");
          $(".header__sublist").removeClass("header__sublist--shown");
          $(".header__subheader").removeClass("header__subheader--shown");
        }
      });

      $(".header__item--withSub").on("mouseenter", function(e) {
        console.log('mouseenter event', e);
        if (window.innerWidth > 1050) {
          $(this).addClass("header__item--hover");
          $(this)
            .children("ul")
            .addClass("header__sublist--shown");

          var elementId = $(this).attr('id');
          var backgraundImage = $(this).children('.header__sublist').children()[0].dataset.image;

          if (subHeaderId !== elementId || (firstImage !== backgraundImage && !triggeredFromHover)) {
            subHeaderId = elementId;
            firstImage = backgraundImage;
            triggeredFromHover = false;
            $(".header__img").attr("src", backgraundImage);

          }

          $(".header__subheader").addClass("header__subheader--shown");
        }
      });

      $(".header__item--withSub").on("mouseleave", function(e) {
        console.log('mouseleave');
      });

      $("main").on("mouseenter", function() {
        if (window.innerWidth > 1050) {
          $(".header__item").removeClass("header__item--hover");
          $(".header__sublist").removeClass("header__sublist--shown");
          $(".header__subheader").removeClass("header__subheader--shown");
        }
      });

      $(".header__subitem").hover(function() {
        if (window.innerWidth > 1050) {
          var image = $(this)[0].dataset.image;
          firstImage = image;
          triggeredFromHover = true;
          console.log('Hover image set', image);
          $(".header__img").attr("src", image);
        }
      });

      $(".header__item--withSub").on("click", function() {
        if ($(this).hasClass("header__item--hover")) {
          if (window.innerWidth < 1051) {
            $(this).removeClass("header__item--hover");
            $(this)
              .children("ul")
              .removeClass("header__sublist--shown");
            $(this)
              .children(".header__sublist-toggle")
              .removeClass("header__sublist-toggle--active");
          }
        } else {
          if (window.innerWidth < 1051) {
            $(this).addClass("header__item--hover");
            $(this)
              .children("ul")
              .addClass("header__sublist--shown");
            $(this)
              .children(".header__sublist-toggle")
              .addClass("header__sublist-toggle--active");
          }
        }
      });
    }

    headerNavChanger();

    // HEADER NAV on TABLETS (port-view) & MOBILES
    $("#nav-toggle").on("click", function() {
      if ($(this).hasClass("header__nav-toggle--active")) {
        $(this).removeClass("header__nav-toggle--active");
        $(".header__nav").removeClass("header__nav--mobile");
      } else {
        $(this).addClass("header__nav-toggle--active");
        $(".header__nav").addClass("header__nav--mobile");
      }
    });

    if (window.innerWidth <= 1050) {
      const subjectHeight = $(".title-subject")[0]?.offsetHeight || 0;
      const headlineHeight = $(".the-latest__headline")[0]?.offsetHeight || 0;
      const authorHeight = $(".the-latest__author")[0]?.offsetHeight || 0;
      const btn = $(".btn--default")[0]?.offsetHeight || 0;
      const newHeight = subjectHeight + headlineHeight + authorHeight + btn;

      $(".the-latest__left")[0].style.height = `calc(${newHeight}px + 20vh)`;
      $(".the-latest__mobile-back")[0].style.height = `calc(${newHeight}px + 20vh)`;
    }

  });
})(jQuery);
